import { computed } from 'mobx';
import { Model } from 'core/model/Model';
import { AssetType } from '@kentik/ui-shared/labels/lib';

export type AssetTagInventoryJson = {
  id: number;
  tag_id: string;
  asset_type: AssetType;
  asset_id: string;
  asset_name: string | null;
  tag_name: string;
  description: string;
  value: string;
  target_value: string;
};

export default class AssetTagInventoryModel extends Model<AssetTagInventoryJson> {
  @computed
  get isNewValue(): boolean {
    return this.get('value') === '';
  }

  @computed
  get valueEdited(): boolean {
    return !this.isNewValue && this.get('value') !== this.get('target_value');
  }

  @computed
  get valueUnchanged(): boolean {
    return !this.isNewValue && !this.valueEdited;
  }

  @computed
  get hasError(): boolean {
    return this.get('target_value') === '';
  }

  @computed
  get canSave(): boolean {
    return !this.hasError && (this.isNewValue || this.valueEdited);
  }
}
